<script setup lang="ts">
import { capitalize } from 'lodash'
import { computed, onMounted, ref } from 'vue'
import { useExtendedI18n } from '@/i18n'
import { RouterLinkBack, VButtonInvisible, VSection, VTable } from '@/modules/shared/components'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import { rails_url } from '@/modules/shared/utils/rails'
import { useEntityStore } from '../stores/entity-store'
import ChecklistEntitiesNav from '../component/checklist-entities-nav.vue'
import AllEntities from '../component/all-entities.vue'
import InProgress from '../component/in-progress.vue'
import { useRoute } from 'vue-router'
///////////////////////////////////////////////////////////////////////////////
// Main
///////////////////////////////////////////////////////////////////////////////

const { t } = useExtendedI18n()

const entityStore = useEntityStore()

const fetchAllEntities = computed(() => entityStore.allEntities)
const inProgress = computed(() => entityStore.inProgressEntities)

const tabs = [
  {
    label: t('All Clients', 0),
    to: { name: 'admin.all-entities' },
  },
  {
    label: t('Funds in Progress', 0),
    to: { name: 'admin.funds-in-progress' },
  },
  {
    label: t('SPVs in Progress', 0),
    to: { name: 'admin.spv-in-progress' },
  },
]

const route = useRoute()
const routes = ['all-entities', 'funds-in-progress', 'spv-in-progress']

const currentTabIndex = computed(() => {
  const segments = route.path.split('/').filter(Boolean)
  const last = segments[segments.length - 1]
  const index = routes.indexOf(last)
  return index !== -1 ? index : 0
})

const fetchTabData = async () => {
  console.log(currentTabIndex.value, 'Fetching tab data')

  switch (currentTabIndex.value) {
    case 0:
      await entityStore.fetchAllEntities()
      break
    case 1:
      await entityStore.fetchInProgress('fund')
      break
    case 2:
      await entityStore.fetchInProgress('spv')
      break
    default:
      console.warn(`Unknown tab index: ${currentTabIndex.value}`)
  }
}

onMounted(async () => {
  await fetchTabData()
})
</script>

<template>
  <TheLayout>
    <div class="-mt-8 mb-6">
      <RouterLinkBack :to="`${rails_url()}/investors`" class="text-lg">
        <VButtonInvisible>← {{ capitalize(t('shared.back')) }}</VButtonInvisible>
      </RouterLinkBack>
    </div>
    <ChecklistEntitiesNav :tabs="tabs" />
    <AllEntities v-if="currentTabIndex == 0" :entities="fetchAllEntities" />
    <InProgress
      v-else-if="currentTabIndex != 0"
      :entities="inProgress"
      :columns="entityStore.columnDefinitions"
    ></InProgress>
  </TheLayout>
</template>
